const Angular = require('angular');
const Directive = require('./DataCaptureListDirective');
const Controller = require('./DataCaptureListController');

const module = Angular.module('dash.topControls.dataCaptureSelector.dataCaptureList', []);


module.controller('DataCaptureListController', Controller);
module.directive('datacaptureList', [Directive]);



// WEBPACK FOOTER //
// ./src/app/dash/topControls/dataCaptureSelector/dataCaptureList/index.js